import { Component } from 'react';
import Isvg from 'react-inlinesvg'
import { API_ENDPOINT } from '../../constants';
import garabage from '../../assets/svg/garbage.svg';

class JournalExports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            items: [],
        };
    }
    deleteExportRecord = (exportEhrId) => {
        if (!exportEhrId?.length === 24) return;

        fetch(API_ENDPOINT + `/api/ehr/exports/${exportEhrId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(res => res.json()).then((result) => {
            this.get();
        })
    }
    getEhrExports = () => {
        const groupId = this.props.selectedGroup ?? null;
        if (!groupId) {
            this.setState({ items: [] });
            return;
        }
        let data = {
            groupId
        };

        fetch(API_ENDPOINT + `/api/ehr/exports`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => res.json()).then((result) => {
            let items = result?.length ? result : [];
            this.setState({ items }, () => {
                if (this.state.items?.find(item => !item?.finished)) {
                    setTimeout(() => {
                        this.get();
                    }, 1000 * 5);
                }
            });
        })
    }

    get = () => {
        this.getEhrExports();
    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();


        this.interval = setInterval(() => {
            this.get();
        }, 60 * 1000);
    }



    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }
    }

    render() {
        const items = this.state.items || [];
        const selectedEhrExport = this.props.selectedEhrExport;
        return (
            <div>
                <div className="panel-header" style={{ marginBottom: 0 }}>
                    <h5 className="component-header">{'EHR logs'.translate(this.props.lang)} </h5>
                </div>

                <div className="payment-exports-wrap">
                    {
                        items?.map((item, idx) => {
                            const url = item?.folderPath && item?.fileName ? `${API_ENDPOINT}${item?.folderPath}${item?.fileName}.xlsx` : null;
                            const isItemSelected = selectedEhrExport === item?._id ? true : false;
                            return (
                                <div className={isItemSelected ? 'payment-exports-item-wrap selected-payment-exports-item-wrap' : 'payment-exports-item-wrap'} key={idx}>
                                    <div className='export-data-wrap'>
                                        <div className='item-title'>{item.fileName}</div>
                                        <div className='item-subtitle'>
                                            {
                                                item?.finished && item?.finishedTs ?
                                                    `${'Exported'.translate(this.props.lang)}: ${this.props.getStringDateTs(item.finishedTs, `${this.props.dateFormat} HH:mm`)}`
                                                    :
                                                    `${'Export started'.translate(this.props.lang)}: ${this.props.getStringDateTs(item.tsCreated, `${this.props.dateFormat} HH:mm`)}`
                                            }
                                            {
                                                item?.user?.username ?
                                                    <>
                                                        <br />
                                                        {`${'Exported by'.translate(this.props.lang)}: ${item?.user?.username}`}
                                                    </>
                                                    :
                                                    null
                                            }

                                        </div>
                                    </div>
                                    <div className='export-data-actions'>
                                        {
                                            !item?.finished ?
                                                `${'In progress'.translate(this.props.lang)}...`
                                                :
                                                <>
                                                    <button className='export-record-delete' onClick={() => this.deleteExportRecord(item._id)}> <Isvg src={garabage} />  <div className="export-record-delete-tooltip">{'Delete'.translate(this.props.lang)}</div> </button>
                                                    {
                                                        url ?
                                                            <a href={url} target={'_blank'}>{'Download'.translate(this.props.lang)}</a>
                                                            :
                                                            null
                                                    }

                                                </>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}


export default JournalExports;
